import React from 'react';
import { string, array, bool, func, oneOfType, object } from 'prop-types';
import {
  StyledHeaderActionItemContent,
  StyledHeaderActionsItem,
  StyledHeaderActions,
  StyledHeaderActionsItemLabel,
  StyledHeaderActionsItemsContainer,
  StyledHeaderActionsTitle,
  StyledHeaderDropdownIcon,
  StyledContainer,
  StyledIconAction,
} from './styles';
import { ssoRedirect } from 'src/utils/ssoRedirect';

export const HeaderActionsDropdown = ({
  options = [],
  toggleDropdown,
  isActive,
  title,
  subtitle,
  headerCustomColor,
}) => {
  const renderMenu = () => {
    const menu = options.map(itemAction => {
      if (React.isValidElement(itemAction)) {
        return itemAction;
      }
      const { icon, link, label, subLabel, logout } = itemAction;
      return (
        <StyledHeaderActionsItem
          key={`${label}-action`}
          href={link}
          label={label}
          onClick={() => {
            if (logout) {
              ssoRedirect.logout();
            }
          }}
          data-test="header-actions__item"
        >
          <StyledHeaderActionItemContent>
            <StyledIconAction icon={icon} size={20} />
            <StyledHeaderActionsItemLabel>{label}</StyledHeaderActionsItemLabel>
            {subLabel && (
              <StyledHeaderActionsItemLabel light>
                {subLabel}
              </StyledHeaderActionsItemLabel>
            )}
          </StyledHeaderActionItemContent>
        </StyledHeaderActionsItem>
      );
    });

    return (
      <StyledHeaderActionsItemsContainer
        hidden={!isActive}
        data-test="header-actions__items-container"
      >
        {menu}
      </StyledHeaderActionsItemsContainer>
    );
  };

  return (
    <StyledHeaderActions
      onClick={toggleDropdown}
      backgroundColor={headerCustomColor?.default}
    >
      <StyledContainer data-test="header-actions__title-container">
        <StyledHeaderActionsTitle primary single={!subtitle && 'single'}>
          {title}
        </StyledHeaderActionsTitle>
        {subtitle && (
          <StyledHeaderActionsTitle secondary>
            {subtitle}
          </StyledHeaderActionsTitle>
        )}
        <StyledHeaderDropdownIcon />
      </StyledContainer>
      {renderMenu()}
    </StyledHeaderActions>
  );
};

HeaderActionsDropdown.propTypes = {
  options: array,
  title: string.isRequired,
  subtitle: oneOfType([string, bool]),
  isActive: bool.isRequired,
  toggleDropdown: func.isRequired,
  headerCustomColor: object,
};
